import { useSingleDataQuery } from 'hooks/useFastGqlQuery';
import { isString } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getSummaryPrice } from 'services/graphql/queries/accounting.query';
import { RoleEnum } from 'types/user';

import AccountingPageContainer from './components/AccountingPageContainer';
import ClientSummaryBox from './components/ClientAccounting/ClientSummaryBox';
import ClientSummaryTable from './components/ClientAccounting/ClientSummaryTable';
import NotarySummaryBox from './components/NotaryAccounting/NotarySummaryBox';
import NotarySummaryTable from './components/NotaryAccounting/NotarySummaryTable';
import SearchAndFilterBar from './components/SearchAndFilterBar';

const Accountings: React.FC = () => {
  const [activeUserRole, setActiveUserRole] = useState<string>(RoleEnum.CLIENT);
  const routeStateRole = useLocation().state;

  useEffect(() => {
    if (routeStateRole && isString(routeStateRole)) {
      setActiveUserRole(routeStateRole);
    }
  }, [routeStateRole]);

  const { content: summaryData, loading } = useSingleDataQuery<{
    totalClientBalance: number;
    totalNotaryGet: number;
  }>(getSummaryPrice, {
    // fetchPolicy: 'network-only',
  });

  const onSummaryBoxClick = (role: RoleEnum) => {
    setActiveUserRole(role);
  };

  return (
    <AccountingPageContainer
      headerBelow={
        <div className='accounting-page-container'>
          <div className='summary-box-container header-section'>
            {!loading && (
              <>
                <ClientSummaryBox
                  mainData={`$${summaryData?.totalClientBalance || 0}`}
                  onClick={() => {
                    onSummaryBoxClick(RoleEnum.CLIENT);
                  }}
                  active={activeUserRole === RoleEnum.CLIENT}
                />
                <NotarySummaryBox
                  mainData={`$${summaryData?.totalNotaryGet || 0}`}
                  onClick={() => {
                    onSummaryBoxClick(RoleEnum.NOTARY);
                  }}
                  active={activeUserRole === RoleEnum.NOTARY}
                />
              </>
            )}
          </div>
          <div className='search-filter-container'>
            <SearchAndFilterBar />
          </div>
        </div>
      }>
      <div className='p-4 sm:p-0'>
        <div className={`${activeUserRole !== RoleEnum.CLIENT ? 'gx-d-none' : ''} accounting-table`}>
          <ClientSummaryTable active={activeUserRole === RoleEnum.CLIENT} />
        </div>
        <div className={`${activeUserRole !== RoleEnum.NOTARY ? 'gx-d-none' : ''} accounting-table`}>
          <NotarySummaryTable active={activeUserRole === RoleEnum.NOTARY} />
        </div>
      </div>
    </AccountingPageContainer>
  );
};

export default React.memo(Accountings);
